module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAMNJREFUSA3tVVEKwjAMfSnFO3gldwevIUwRERG9hmfQXWmXGMakczL8WCLYj0EDgUBeXtM0vBK2/ABjhRxGaEIO3hEnj+KvsGaGumUGLvcNMP8DCAdeoMNRNmktvrRG7soTWhBuiNjHRP7ExlXoBWmjLJwd5AztXC2gwokaL8ckruZK8nflps8qnokmi35Nvld8/ltUbmA+fRlRGZE5ARMQRFbbhOoFyixwAQYu4Sbs+IJ/y/XQRcA16qegup1kO8OH8wLzhzjOyXaU6gAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sign/icon-bj.png
// module id = 419
// module chunks = 2